import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'

export const TextTitleDescription = ({
    as,
    title,
    titleSpacing,
    alignment = 'center',
    textStyle = 'display-large',
    fontWeight = 'semibold',
    color = 'foreground.neutral.default',
    childrenTextStyle = 'body-xlarge',
    childrenTextWeight = 'normal',
    childrenTextColor = 'foreground.neutral.default',
    textTransform = 'none',
    noMinHeight = false, // if true, the title will be rendered as h2 tag
    fontFamily = 'heading',

    ...props
}) => {
    return (
        <Box textAlign={alignment} textTransform={textTransform} {...props}>
            {title && (
                <Box
                    as={as}
                    textStyle={textStyle}
                    color={color}
                    fontWeight={fontWeight}
                    mb={titleSpacing}
                    fontFamily={fontFamily}
                >
                    {' '}
                    <Box>{title}</Box>
                </Box>
            )}
            {props.children && (
                <Box
                    textStyle={childrenTextStyle}
                    fontWeight={childrenTextWeight}
                    color={childrenTextColor}
                    minHeight={
                        noMinHeight
                            ? 'auto'
                            : {
                                  base: 'initial',
                                  sm: remCalc(60),
                                  md: remCalc(80),
                                  lg: remCalc(100),
                                  xl: remCalc(60),
                              }
                    }
                >
                    <Text>{props.children}</Text>
                </Box>
            )}
        </Box>
    )
}

TextTitleDescription.propTypes = {
    as: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alignment: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    textStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string,
    childrenTextStyle: PropTypes.string,
    childrenTextWeight: PropTypes.string,
    childrenTextColor: PropTypes.string,
    textTransform: PropTypes.string,
    noMinHeight: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleAs: PropTypes.string,
    fontFamily: PropTypes.string,
}
